import { combineReducers } from 'redux'
import { IGlobalMessagingState } from 'types/globalMessaging'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import { IShipperRatesState, IModalsState } from 'apps/rms/types/shipperRates'
import modalsReducer from 'apps/rms/utils/reducers/modals'
import shipperRatesReducer from './shipperRates'

export interface IStore {
  globalMessaging: IGlobalMessagingState
  shipperRates: IShipperRatesState
  modals: IModalsState
}

const reducers = combineReducers({
  globalMessaging: globalMessagingReducer,
  shipperRates: shipperRatesReducer,
  modals: modalsReducer,
})

export default reducers
